import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizExpiredTranslations: Quiz409Translations = {
  title: 'Oops! You ran out of time.',
  subMessage: "This year you didn't manage to complete all the qualification tasks.",
  buttons: {
    back: 'Back',
  },
};
